module.exports = __webpack_public_path__ + "img/symbol_7.65ed8327.png";